/**
 * Sidebar per-group accordion collapse persist (S03).
 *
 * Mirror pattern lib/sidebar.ts nhưng lưu danh sách các group ĐANG GẬP (JSON array các
 * labelKey) dưới key "gp_admin_sidebar_groups". Default: mọi group MỞ → không có key nào
 * trong danh sách. localStorage có thể bị chặn (private mode) hoặc chứa JSON hỏng →
 * fail-safe về "tất cả mở" (Set rỗng), KHÔNG crash UX.
 */
export const SIDEBAR_GROUPS_STORAGE_KEY = "gp_admin_sidebar_groups";

/** Đọc các group đang gập đã lưu; chưa lưu / lỗi / dữ liệu lạ → Set rỗng (tất cả mở). */
export function resolveCollapsedGroups(): Set<string> {
  if (typeof localStorage === "undefined") return new Set();
  try {
    const raw = localStorage.getItem(SIDEBAR_GROUPS_STORAGE_KEY);
    if (!raw) return new Set();
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter((k): k is string => typeof k === "string"));
  } catch {
    // JSON hỏng hoặc localStorage bị chặn — rơi về "tất cả mở".
    return new Set();
  }
}

/** Gập (true) / mở (false) một group rồi persist. Không lưu được vẫn không chặn UX. */
export function persistCollapsedGroup(key: string, collapsed: boolean): void {
  if (typeof localStorage === "undefined") return;
  const current = resolveCollapsedGroups();
  if (collapsed) current.add(key);
  else current.delete(key);
  try {
    localStorage.setItem(SIDEBAR_GROUPS_STORAGE_KEY, JSON.stringify([...current]));
  } catch {
    // Bỏ qua: trạng thái vẫn sống trong phiên hiện tại.
  }
}
